import { type TutorBotDataReceivedCallback } from '../TutorBotVoiceAgent.types';
import { isErrorMessage } from './DataMessage';

export const errorEventListener: TutorBotDataReceivedCallback = ({ message }) => {
    if (message && isErrorMessage(message)) {
        console.error('Voice Agent error: ', message);
    }
};
